import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Label, Col, Row} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";

class RemoveBusinessAmbassadorModal extends Component {
    render() {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Modal className="ba-remove-modal" isOpen={this.props.isOpen}
                   toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <div>
                <Label>
                    {_.get(this.props.translation, 'business_ambassadors.remove_ambassador_alert')}
                </Label>
                {this.renderData()}
                <div className="modal-buttons-container">
                    <Button color="secondary"
                            onClick={this.handleCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="olive-green-btn"
                            onClick={this.handleRemove}>{_.get(this.props.translation, sharedLabelsPath.remove_button)}</Button>
                </div>
            </div>
        );
    }

    renderData = () => {
        let paramsList = [
            {
                key: "firstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label),
                value: this.props.data.firstName
            },
            {
                key: "lastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label),
                value: this.props.data.lastName
            },
            {
                key: "email",
                title: _.get(this.props.translation, sharedLabelsPath.email_label),
                value: this.props.data.email
            },
            {
                key: "phoneNumber",
                title: _.get(this.props.translation, sharedLabelsPath.phone_number_label),
                value: this.props.data.phoneNumber
            },
            {
                key: "countryCode",
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                value: this.props.data.countryCode
            },
            {
                key: "financialData",
                title: _.get(this.props.translation, 'business_ambassadors.financial_data_label'),
                value: this.props.data.financialData
            }
        ];

        return [..._.map(paramsList, this.getDataRow)]
    };

    getDataRow = (params) => {
        if (_.isNil(params.value)) {
            return null;
        }

        return (
            <Row className="modal-form-field-container" key={params.key}>
                <Col sm={4}>
                    {params.title}
                </Col>
                <Col>
                    {params.value}
                </Col>
            </Row>
        );
    };

    handleRemove = (e) => {
        e.preventDefault();

        this.props.onBusinessAmbassadorRemove(this.props.data.id);
        this.props.onClose();
    };

    handleCancel = () => {
        this.props.onClose();
        this.props.onCancelRemoving();
    };
}

RemoveBusinessAmbassadorModal.propTypes = {
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onBusinessAmbassadorRemove: PropTypes.func,
    onClose: PropTypes.func,
    onCancelRemoving: PropTypes.func
};

export default RemoveBusinessAmbassadorModal;



// WEBPACK FOOTER //
// ./src/components/businessAmbassadorsManagement/removeBusinessAmbassadorModal/RemoveBusinessAmbassadorModal.js